import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Title = styled.h2`
  ${tokens.text('subtitle1')};
`;
